export default "__VITE_ASSET__BuWNvR51__"